import { Attachment, AttachmentWrapper } from '@wizeoo/akm-message-lib';
import { WizCommand, WizIcon, WizPopUp } from '@wizeoo/akm-component-lib';
import { Model } from '../../../model/model';
import { ExternalAPI } from '../../../model/external-api';
import { WIZ_COMMAND_METHOD } from '@wizeoo/akm-core-lib';

/**
 * chargement des médias V2
 * Author LMA
 */
export class AttachmentCmd extends WizCommand<Attachment> {

  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  } 
  
  /** méthode appelée au retour de la commande */
  public sourceCallback: Function;
  public sourceAttachment: Attachment;
  public method: string;
  public resultMode: string = 'DOWN'; // DOWN ou BINARY

  public feedWrapper(attachment: Attachment, method: string): AttachmentWrapper {
    let wrapper: AttachmentWrapper = new AttachmentWrapper();
    attachment.v2 = true;
    attachment.domain = this.model.domainCode;
    attachment.businessUnitCode = this.model.businessUnitCode;
    attachment.vision = this.model.currentVision?.code;

    wrapper.entity = attachment;
    wrapper.method = method;
    return wrapper;
  }

  /** chargement du fichier pour récupération du binaire */
  // public getByteV2(attachment: Attachment, sourceCallback: Function = null): AttachmentCmd {
  //   this.sourceAttachment = attachment;
  //   this.method = WIZ_COMMAND_METHOD.GET;
  //   this.resultMode = 'BINARY';
  //   let wrapper: AttachmentWrapper =  this.feedWrapper(this.sourceAttachment, this.method);

  //   this.configureRemote(ExternalAPI.ATTACHMENTV2, wrapper);
  //   this.sourceCallback = sourceCallback;
  //   return this;
  // }


  /** chargement spécifique sur contextGuard */
  public get(attachment: Attachment, sourceCallback: Function = null): AttachmentCmd {
    this.sourceAttachment = attachment;
    this.method = WIZ_COMMAND_METHOD.GET;
    let wrapper: AttachmentWrapper =  this.feedWrapper(this.sourceAttachment, this.method);
    
    this.configureRemote(ExternalAPI.ATTACHMENTV2, wrapper);
    this.sourceCallback = sourceCallback;
    return this;
  }

    /** appelé depuis batchEngine */
    public create(attachment: Attachment, sourceCallback: Function = null): AttachmentCmd {
      this.sourceAttachment = attachment;

      this.method = WIZ_COMMAND_METHOD.CREATE;
      let wrapper: AttachmentWrapper =  this.feedWrapper(this.sourceAttachment, this.method);
      this.configureRemote(ExternalAPI.ATTACHMENTV2, wrapper);
      this.sourceCallback = sourceCallback;
      return this;
    }

  /** sur retour, traitement selon la méthode */
  public wizResult() {
    super.wizResult();

    const result: Attachment = this.result;
    
    if(!!result) {

        if(this.method === WIZ_COMMAND_METHOD.GET) {
          //let byteArray = result.bytes;
          let byteArray = new Uint8Array(atob(result.bytes).split('').map((char) => char.charCodeAt(0)));

          const file = new Blob([byteArray], { type: result.fileType });
      
          if(this.resultMode === 'DOWN') {
            const fileUrl = URL.createObjectURL(file);
            let link = document.createElement('a');
            link.download = result.fileName;
            link.target = '_blank';
            link.href = fileUrl;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } 
        }

        if(!!this.sourceCallback) {
          this.sourceCallback(result);
        }
    } else {
      WizPopUp.toast('$.nosuchfile.error.$', WizIcon.TOAST_ERROR).show();

    }
  }

}
